import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0); // ページの上部に瞬間的に移動
        } else {
            // ハッシュがある場合、対応する要素にスクロール
            setTimeout(() => {
                const element = document.getElementById(hash.replace("#", ""));
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 100); // DOMの描画を待つ
        }
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
